import ButtonV2 from "components/individual/ButtonsV2/Button";
import React, { useContext } from "react";
import { AddRolContext } from "../..";

export default function ContinueButton() {
  const { handleAddRol } = useContext(AddRolContext);

  return <ButtonV2 onClick={handleAddRol}>Crear rol</ButtonV2>;
}
